var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "simple-form" },
    [
      _c(
        "el-form",
        {
          ref: "shopDeviceInfo",
          staticClass: "demo-ruleForm",
          attrs: { model: _vm.shopDevice, rules: _vm.shopDeviceRules }
        },
        [
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", { staticClass: "required" }, [_vm._v("资产描述全称")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "title" } },
                  [
                    _c("el-input", {
                      staticStyle: { width: "300px" },
                      attrs: {
                        disabled: "true",
                        placeholder: "请输入设备名称"
                      },
                      model: {
                        value: _vm.shopDevice.title,
                        callback: function($$v) {
                          _vm.$set(_vm.shopDevice, "title", $$v)
                        },
                        expression: "shopDevice.title"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.shopDevice.sellerId != null
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("供应商名称")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.shopDevice.sellerName))])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.shopDevice.brandId != null
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", [_vm._v("品牌")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.shopDevice.brandName))])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("分类")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.shopDevice.catName))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("商品标识码")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.shopDevice.vendorUkno || ""))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _vm.devcGroupEdit
                ? _c("label", { staticClass: "required" }, [_vm._v("维保分组")])
                : _c("label", [_vm._v("维保分组")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value width-2x" }, [
              _vm.devcGroupEdit
                ? _c(
                    "span",
                    [
                      _c("el-input", {
                        staticClass: "width-1-5x bottom-line",
                        attrs: { readonly: true },
                        model: {
                          value:
                            _vm.shopDevice.devcMaintAspkt.devcGroupFullName,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.shopDevice.devcMaintAspkt,
                              "devcGroupFullName",
                              $$v
                            )
                          },
                          expression:
                            "shopDevice.devcMaintAspkt.devcGroupFullName"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "swb-btn swb-btn-link",
                          on: {
                            click: function($event) {
                              _vm.selectDevcGroup(_vm.shopDevice)
                            }
                          }
                        },
                        [_vm._v("选择")]
                      )
                    ],
                    1
                  )
                : _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.shopDevice.devcMaintAspkt.devcGroupFullName || ""
                      )
                    )
                  ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("系统编号")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.shopDevice.tmpNo))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("服务子号")])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-value" }, [
              _c("span", [_vm._v(_vm._s(_vm.shopDevice.svcSubNo || "无"))])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("责任部门")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-2x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "departName" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { readonly: true },
                      model: {
                        value: _vm.shopDevice.devcMgmtAspkt.respblDepartName,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.shopDevice.devcMgmtAspkt,
                            "respblDepartName",
                            $$v
                          )
                        },
                        expression: "shopDevice.devcMgmtAspkt.respblDepartName"
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "swb-btn swb-btn-link",
                        on: {
                          click: function($event) {
                            _vm.setStaff(_vm.shopDevice.retailerBizUnitId)
                          }
                        }
                      },
                      [_vm._v("选择")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("责任人")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-2x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "principalName" } },
                  [
                    _c("el-input", {
                      staticClass: "width-1-5x bottom-line",
                      attrs: { readonly: true },
                      model: {
                        value: _vm.shopDevice.devcMgmtAspkt.respblStaffName,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.shopDevice.devcMgmtAspkt,
                            "respblStaffName",
                            $$v
                          )
                        },
                        expression: "shopDevice.devcMgmtAspkt.respblStaffName"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.fuscakAcc != null && _vm.fuscakAcc == true
            ? _c("div", [
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("残值率(%)")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "rmnWorthRatio" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入残值率",
                              type: "number",
                              min: 0,
                              disabled:
                                _vm.shopDevice.devcAssetAspkt.devcDefId !=
                                  null &&
                                _vm.shopDevice.devcAssetAspkt.devcDefId != -1
                            },
                            model: {
                              value:
                                _vm.shopDevice.devcAssetAspkt.rmnWorthRatio,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.shopDevice.devcAssetAspkt,
                                  "rmnWorthRatio",
                                  $$v
                                )
                              },
                              expression:
                                "shopDevice.devcAssetAspkt.rmnWorthRatio"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.shopDevice.editOrgWorth
                  ? _c("div", { staticClass: "form-group" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", { staticClass: "required" }, [
                          _vm._v("原值（元）")
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-1-5x" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "orgWorth" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: "请输入原值",
                                  type: "number",
                                  min: 0
                                },
                                model: {
                                  value: _vm.shopDevice.devcAssetAspkt.orgWorth,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.shopDevice.devcAssetAspkt,
                                      "orgWorth",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "shopDevice.devcAssetAspkt.orgWorth"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticClass: "form-group" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", { staticClass: "required" }, [
                      _vm._v("使用年限(月)")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value width-1-5x" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "durableLife" } },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: "请输入净值",
                              disabled:
                                _vm.shopDevice.devcAssetAspkt.devcDefId !=
                                  null &&
                                _vm.shopDevice.devcAssetAspkt.devcDefId != -1,
                              type: "number",
                              min: 1
                            },
                            on: {
                              change: function($event) {
                                _vm.expectedLifeChange(_vm.shopDevice)
                              }
                            },
                            model: {
                              value: _vm.shopDevice.devcAssetAspkt.durableLife,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.shopDevice.devcAssetAspkt,
                                  "durableLife",
                                  $$v
                                )
                              },
                              expression:
                                "shopDevice.devcAssetAspkt.durableLife"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("统一商品代码(UPC)")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-1-5x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "upn" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入UPC" },
                      model: {
                        value: _vm.shopDevice.upc,
                        callback: function($$v) {
                          _vm.$set(_vm.shopDevice, "upc", $$v)
                        },
                        expression: "shopDevice.upc"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("外部系统编号")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-1-5x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "innerNo" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入外部系统编号" },
                      model: {
                        value: _vm.shopDevice.innerNo,
                        callback: function($$v) {
                          _vm.$set(_vm.shopDevice, "innerNo", $$v)
                        },
                        expression: "shopDevice.innerNo"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("厂商序列号")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-1-5x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "vendorSn" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入厂商序列号" },
                      model: {
                        value: _vm.shopDevice.vendorSn,
                        callback: function($$v) {
                          _vm.$set(_vm.shopDevice, "vendorSn", $$v)
                        },
                        expression: "shopDevice.vendorSn"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("位置编码")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-2x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "locCode" } },
                  [
                    _c("span", [_vm._v("SBWZ")]),
                    _vm._v(" "),
                    _c("el-input", {
                      staticClass: "width-1-5x",
                      attrs: { placeholder: "请输入位置编码" },
                      model: {
                        value: _vm.shopDevice.locCode,
                        callback: function($$v) {
                          _vm.$set(_vm.shopDevice, "locCode", $$v)
                        },
                        expression: "shopDevice.locCode"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          !(_vm.fuscakAcc != null && _vm.fuscakAcc == true)
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [_vm._v("需要控温")])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-1-5x" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "temperFlag" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.shopDevice.devcMaintAspkt.temperFlag,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.shopDevice.devcMaintAspkt,
                                  "temperFlag",
                                  $$v
                                )
                              },
                              expression: "shopDevice.devcMaintAspkt.temperFlag"
                            }
                          },
                          [
                            _c("el-radio", { attrs: { label: true } }, [
                              _vm._v("需要")
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: false } }, [
                              _vm._v("不需要")
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.shopDevice.devcMaintAspkt.temperFlag
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [
                    _vm._v("温度低值(°c)")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value width-3x" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "temperLow" } },
                      [
                        _c("el-input", {
                          staticClass: "inline-block width-1-5x",
                          attrs: { placeholder: "请输入温度" },
                          on: {
                            change: function($event) {
                              _vm.temperLowChange(_vm.shopDevice)
                            }
                          },
                          model: {
                            value: _vm.shopDevice.devcMaintAspkt.temperLow,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.shopDevice.devcMaintAspkt,
                                "temperLow",
                                $$v
                              )
                            },
                            expression: "shopDevice.devcMaintAspkt.temperLow"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "inline-block font-orange" },
                          [_vm._v("只保留两位小数")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.shopDevice.devcMaintAspkt.temperFlag
            ? _c("div", { staticClass: "form-group center" }, [
                _c("div", { staticClass: "form-label" }, [
                  _c("label", { staticClass: "required" }, [
                    _vm._v("温度高值(°c)")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-value " },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { prop: "temperHigh" } },
                      [
                        _c("el-input", {
                          staticClass: "inline-block width-1-5x",
                          attrs: { placeholder: "请输入温度" },
                          on: {
                            change: function($event) {
                              _vm.temperHighChange(_vm.shopDevice)
                            }
                          },
                          model: {
                            value: _vm.shopDevice.devcMaintAspkt.temperHigh,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.shopDevice.devcMaintAspkt,
                                "temperHigh",
                                $$v
                              )
                            },
                            expression: "shopDevice.devcMaintAspkt.temperHigh"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "inline-block font-orange" },
                          [_vm._v("只保留两位小数")]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("备注")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-2x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "memo" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", placeholder: "请描述备注" },
                      model: {
                        value: _vm.shopDevice.memo,
                        callback: function($$v) {
                          _vm.$set(_vm.shopDevice, "memo", $$v)
                        },
                        expression: "shopDevice.memo"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("备注1")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-2x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "memo" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", placeholder: "请描述备注" },
                      model: {
                        value: _vm.shopDevice.memo1,
                        callback: function($$v) {
                          _vm.$set(_vm.shopDevice, "memo1", $$v)
                        },
                        expression: "shopDevice.memo1"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("备注2")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-2x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "memo" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", placeholder: "请描述备注" },
                      model: {
                        value: _vm.shopDevice.memo2,
                        callback: function($$v) {
                          _vm.$set(_vm.shopDevice, "memo2", $$v)
                        },
                        expression: "shopDevice.memo2"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("备注3")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value width-2x" },
              [
                _c(
                  "el-form-item",
                  { attrs: { prop: "memo" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea", placeholder: "请描述备注" },
                      model: {
                        value: _vm.shopDevice.memo3,
                        callback: function($$v) {
                          _vm.$set(_vm.shopDevice, "memo3", $$v)
                        },
                        expression: "shopDevice.memo3"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ]),
          _vm._v(" "),
          _vm.showDevcCustTag
            ? [
                _vm.devcCustTag1.enabled
                  ? _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v(_vm._s(_vm.devcCustTag1.dispName))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-2x" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "devcCustTag1" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    disabled: _vm.devcCustTag1.refUsed,
                                    placeholder: "请选择",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.shopDevice.devcCustTag1,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.shopDevice,
                                        "devcCustTag1",
                                        $$v
                                      )
                                    },
                                    expression: "shopDevice.devcCustTag1"
                                  }
                                },
                                _vm._l(_vm.devcCustTag1.itemList, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    attrs: {
                                      label: item.disabled
                                        ? item.name + "(已禁用)"
                                        : item.name,
                                      value: item.id,
                                      disabled: item.disabled
                                    }
                                  })
                                })
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.devcCustTag2.enabled
                  ? _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v(_vm._s(_vm.devcCustTag2.dispName))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-2x" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "devcCustTag2" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    disabled: _vm.devcCustTag2.refUsed,
                                    placeholder: "请选择",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.shopDevice.devcCustTag2,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.shopDevice,
                                        "devcCustTag2",
                                        $$v
                                      )
                                    },
                                    expression: "shopDevice.devcCustTag2"
                                  }
                                },
                                _vm._l(_vm.devcCustTag2.itemList, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    attrs: {
                                      label: item.disabled
                                        ? item.name + "(已禁用)"
                                        : item.name,
                                      value: item.id,
                                      disabled: item.disabled
                                    }
                                  })
                                })
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.devcCustTag3.enabled
                  ? _c("div", { staticClass: "form-group center" }, [
                      _c("div", { staticClass: "form-label" }, [
                        _c("label", [_vm._v(_vm._s(_vm.devcCustTag3.dispName))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "form-value width-2x" },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "devcCustTag3" } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticStyle: { width: "150px" },
                                  attrs: {
                                    disabled: _vm.devcCustTag3.refUsed,
                                    placeholder: "请选择",
                                    clearable: ""
                                  },
                                  model: {
                                    value: _vm.shopDevice.devcCustTag3,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.shopDevice,
                                        "devcCustTag3",
                                        $$v
                                      )
                                    },
                                    expression: "shopDevice.devcCustTag3"
                                  }
                                },
                                _vm._l(_vm.devcCustTag3.itemList, function(
                                  item
                                ) {
                                  return _c("el-option", {
                                    attrs: {
                                      label: item.disabled
                                        ? item.name + "(已禁用)"
                                        : item.name,
                                      value: item.id,
                                      disabled: item.disabled
                                    }
                                  })
                                })
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ]
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "form-group center" }, [
            _c("div", { staticClass: "form-label" }, [
              _c("label", [_vm._v("资产图片")])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c("swb-file-upload", {
                  attrs: {
                    fileFor: "solution",
                    fileGroup: "image-misc",
                    onBeforeUpload: _vm.onBeforeUpload,
                    onProgress: _vm.onProgress,
                    onDone: _vm.onUploadDone,
                    multipleFile: false
                  }
                }),
                _vm._v(" "),
                _vm.shopDeviceImg.fileBrowseUrl != null
                  ? _c(
                      "div",
                      { staticClass: "file-area clearfix" },
                      [
                        _c("swb-file-item", {
                          attrs: {
                            fileName: _vm.shopDeviceImg.fileName,
                            fileBrowseUrl: _vm.shopDeviceImg.fileBrowseUrl,
                            fileUuid: _vm.shopDeviceImg.fileUuid,
                            deletable: true,
                            onDelete: _vm.removeUpload
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64254131", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64254131","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/retailer/ShopDeviceSvcSubNoEdit.vue
// module id = 3079
// module chunks = 0